<template>
    <v-select 
       :value="selected_incidenttypes" 
       v-bind:items="incidenttypes"
       item-value="code" 
       item-text="description" 
       :label="label"
       :clearable="isClearable"
       :multiple="isMultiple"
       @change="updateData">
        <template v-slot:selection="{ item, index }">
            <v-chip small v-if="index >= 0 && index < visibleChips">
                <span>{{ item.description }}</span>
            </v-chip>
            <span v-if="index === visibleChips" class="grey--text text-caption">(+{{ selected_incidenttypes.length - visibleChips }})</span>
        </template>                                                        
     
    </v-select>
</template>

<script>
export default {
    props: {
        selected_incidenttypes: {
            type: Array,
            default: function() { return []; },
        },
        label: {
            type: String,
            default: 'Incident type'
        },   
        field: {
            default: 'incidenttype',
            required: true,
        },
        isClearable:{
            type: Boolean,
            default: false
        },
        isMultiple:{
            type: Boolean,
            default: true
        },  
        visibleChips:{
            type: Number,
            default: 2
        }
    },
    data() {
        return {
            incidenttypes: [],
        }
    },
    created() {
        this.getIncidentTypes();
    },
    methods: {
        getIncidentTypes() {
            this.$axios
                .post("ares/json/ares/huov/hokl/getKlct.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getKlct"
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        this.showDialog('error', 'Error', res.data.error.message);
                    } else {
                        this.incidenttypes = res.data.getKlct;
                    }
                })
        },
        updateData(v){
            this.$emit('updateData', { "field": this.field, "value": v === null ? '' : v })
        }
    }
}
</script>

<style scoped>

</style>